
import { getById } from "@insite/client-framework/Store/Data/DataState";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";

export function getOrderDetailsState(state: CustomApplicationState, orderNumber: string | undefined) {
    return getById(state.WhiteCap.orderDetailsCustom, orderNumber, id => state.WhiteCap.orderDetailsCustom.idByOrderNumber[id]);
}